<template>
  <codemirror :value="code"
              :options="cmOption"
              class="CodeMirror-auto-height"
  />
</template>

<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/mode/htmlmixed/htmlmixed.js'
import 'codemirror/mode/javascript/javascript'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-light.css'
import 'codemirror/theme/neo.css'
import 'codemirror/theme/lucario.css'

import { objectStringify } from '@/utils/misc'

export default {
  name: 'JsonPrint',
  components: {
    codemirror
  },
  props: {
    json: {type: String, default: null},
    value: {type: Object | Array, default: null},
    options: {type: Object, default: null}
  },
  data () {
    return {
      cmOption: {
        tabSize: 4,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: true,
        mode: 'javascript',
        theme: 'neo',
        ...this.options
      }
    }
  },
  computed: {
    code () {
      const code = this.value != null ? objectStringify(this.value, 2) : this.json
      return code
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/JsonPrint.vue